var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordmarkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    viewBox: "0 0 240 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12C28 12 24 8 18 8C10 8 6 15 6 20C6 25 10 32 18 32C24 32 28 28 28 28",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20,
    r: 2.5,
    fill: "#00D4AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 18.5,
    width: 5,
    height: 3,
    fill: "#00D4AA"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 32,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#0A0A0F"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#00D4AA"
  }, "Cipher"), /*#__PURE__*/React.createElement("tspan", null, "Swap"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmarkLogo);
export default __webpack_public_path__ + "static/media/wordmark-logo.0863aa49e21432b7a68e931feebdb615.svg";
export { ForwardRef as ReactComponent };